import { generate } from "@ant-design/colors";
const COLORS = {};

export function themeColors(color) {
  if (!COLORS[color]) {
    COLORS[color] = generate(color);
  }
  return COLORS[color];
}
